module.exports = __webpack_public_path__ + "footer-logo-ig-pl.png?792ab377b1604babc1ed9bf2329ba74f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer-logo-ig-pl.png
// module id = 940
// module chunks = 0